export default "__VITE_ASSET__UDLnrNYr__"